import { render, staticRenderFns } from "./LookClassView.vue?vue&type=template&id=428a5715&scoped=true&"
import script from "./LookClassView.vue?vue&type=script&lang=js&"
export * from "./LookClassView.vue?vue&type=script&lang=js&"
import style0 from "./LookClassView.vue?vue&type=style&index=0&id=428a5715&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428a5715",
  null
  
)

export default component.exports